// extracted by mini-css-extract-plugin
export default {"Ending":"Ending_Ending__r4wsD","Ending__container":"Ending_Ending__container__dbZSo","Title":"Ending_Title__CX6+m","Subtitle":"Ending_Subtitle__XKel+","Check":"Ending_Check__3YYqR"};